import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const Wrapper = styled.div``;

export const TableContainer = styled.ul`
  li {
    border-radius: ${theme.border.radius.small};
    color: ${theme.colors.gray6};
    padding: 1rem 1.875em;
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.6em;
    font-size: max(0.9rem, 0.8vw);
  }

  @media all and (max-width: ${theme.grid.tablet.breakpoint}) {
    li {
      display: block;
    }
  }
`;

export const TableHeader = styled.li`
  font-size: inherit;

  @media all and (max-width: ${theme.grid.tablet.breakpoint}) {
    display: none !important;
  }

  &.isHeader {
    padding: 0 1.875em;
    color: ${theme.colors.gray5};
  }
`;

export const TableRow = styled.li`
  background-color: #ffffff;
  box-shadow: ${theme.shadow.small};

  &:hover {
    cursor: pointer;
    box-shadow: ${theme.shadow.lv1};
  }

  .chevron {
    width: 35px;
    height: 25px;
  }

  @media all and (max-width: ${theme.grid.tablet.breakpoint}) {
    .chevron { display: none; }
  }
`;

export const Col = styled.div`
  flex-basis: 100%;
  display: flex;
  align-items: center;
  user-select: none;
  font-size: inherit;
  color: inherit;

  span {
    display: flex;
    align-items: center;
    margin-left: 0.5em;

    svg {
      width: 1.4em;
      height: auto;

      &.isHover {
        transform: scale(1);

        &:hover {
          cursor: pointer;
          transform: scale(1.2);
        }
      }
    }
  }

  p.text {
    display: block;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.selected {
    text-decoration: underline;
  }

  @media all and (max-width: ${theme.grid.tablet.breakpoint}) {
    display: flex;
    padding: 0.625em 0;

    &:before {
      color: ${theme.colors.gray5};
      padding-right: 0.625em;
      content: attr(data-label);
      flex-basis: 50%;
      text-align: right;
    }
  }
`;

export const ContentIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: .2rem;

  svg {
    width: 1.2rem;
    height: auto;
    transform: scale(1);

    :hover {
      transform: scale(1.1);
      cursor: pointer;
    }

    &.rotate {
      transform: rotateX(180deg);
    }
  }
`;
